function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillOpacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  d: "m63.8122 72.7283c-22.3743 14.3119-50.9822 18.9851-63.8122 18.0811v3.1642c6.58379.1507 24.4107-.2712 43.0479-3.1642 23.2965-3.6162 39.162-9.2404 68.8761-18.0811 19.752-5.8764 36.971-11.7527 88.628-17.1771 30.387-3.1908 66.851-1.8081 74.448 0v-54.695312c-12.155-.9041146-25.829-1.356112-44.061 0-41.826 3.111042-61.42 7.533362-95.718 24.861412-26.842 13.5609-41.0221 27.5737-71.4088 47.011z",
  fill: "#bf6196"
}), /*#__PURE__*/React.createElement("path", {
  d: "m211.188 69.224c22.374-6.8789 50.982-9.125 63.812-8.6905v-1.5208c-6.584-.0724-24.411.1304-43.048 1.5208-23.296 1.7381-39.162 4.4413-68.876 8.6904-19.752 2.8245-36.971 5.6488-88.6285 8.2559-30.3867 1.5336-66.85079.8691-74.44749855 0l-.00000028 3.2409c12.15469883.4345 25.82869883 3.2583 44.06079883 2.6065 41.8258-1.4952 61.4202 16.8208 95.7182 8.4919 26.842-6.5178 41.022-13.2529 71.409-22.5951z",
  fill: "#ece134"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 41.5038v-31.5038c6.98726 1.5002 23.177 5.1512 39.3673 8.501 26.5857 5.5007 40.6201 5.0824 54.1939 12.5015 34.7658 19.0023 22.4958 29.0035 55.7278 38.5047 33.232 9.5011 41.923 11.6442 60.329 12.5015 15.338.7144 57.883.1581 65.382-1.0087v22c0 .911-18.005 2.345-33.684 4.512-8.862.5-42.435 1.5-61.351-2.501-13.143-2.779-26.075-10.0007-43.969-27.5029-17.894-17.5021-40.3898-23.5028-75.1557-28.5034-27.8127-4.0005-35.7884-4.0005-60.8403-7.5009z",
  fill: "#8bc24a"
}));

var SvgFlowGraph = function SvgFlowGraph(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 108,
    viewBox: "0 0 275 108",
    width: 275,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlowGraph, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flow-graph.2f13e468.svg";
export { ForwardRef as ReactComponent };